import React, { useState } from "react";
import { PasswordInput, Stack, Group, Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { validatePassword } from "../../utils/passwordValidation";

function PasswordRequirementInput({
  value,
  onChange,
  label = "Password",
  placeholder = "Enter password",
  error,
  showRequirements = true,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);
  const requirements = validatePassword(value);
  const checks = requirements.map((requirement) => (
    <Group
      key={requirement.id}
      c={requirement.meets ? "green" : "red"}
      align="center"
      gap={8}
    >
      {requirement.meets ? <IconCheck size={14} /> : <IconX size={14} />}
      <Text size="sm">{requirement.label}</Text>
    </Group>
  ));

  // Show requirements only when focused (hide when blurred, even if password is present)
  const shouldShowRequirements = showRequirements && isFocused;

  return (
    <Stack gap="xs">
      <PasswordInput
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        label={label}
        placeholder={placeholder}
        error={error}
        styles={{
          label: {
            fontWeight: 500,
            marginBottom: 8,
            color: "#101820",
          },
        }}
        {...props}
      />

      {shouldShowRequirements && <Stack gap={4}>{checks}</Stack>}
    </Stack>
  );
}

export default PasswordRequirementInput;
